module.exports = __webpack_public_path__ + "static/locales/id.27-ICob.json";